var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topnav {\n  overflow: hidden;\n  padding-left: 24%;\n  padding-right: 20%;\n}\n\n.nav-link {\n  float: left;\n  text-align: center;\n  text-decoration: none;\n  font-size: 17px;\n  color: #333;\n}\n\n.topnav a:hover {\n  background-color: transparent;\n}\n\n#main-img {\n  margin-left: 2em;\n  -o-object-fit: cover;\n     object-fit: cover;\n  height: 50%;\n  width: 90%;\n}\n\n.wrapper {\n  margin-top: 0;\n  height: 70vh;\n  background-image: url(" + escape(require("../../assets/img/landing-page.jpg")) + ");\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.row {\n  padding-top: 0.5em;\n}\n\n.main-text-box {\n  text-align: center;\n  display: table;\n  margin-right: auto;\n  margin-left: auto;\n  margin-top: 20vh;\n  padding: 1em;\n  background-color: rgba(47, 143, 130, 0.8);\n}\n\n.main-text-box h3,\np {\n  color: white;\n}\n\n.auth {\n  font-weight: 800;\n  font-size: 0.8em;\n  background-color: #fd8a10;\n  padding: 0.5em 2em 0.5em 2em;\n  margin-top: 0.5em;\n}\n\n.topnav-list li {\n  list-style-type: none;\n  display: inline-block;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/skye/Projects/Epicodus Projects/JavaScript/mock-mint/src/app/navbar/navbar.component.css
// module id = ../../../../../src/app/navbar/navbar.component.css
// module chunks = main